/**
 * @file 消耗总览
 * @author gaoxunchen
 */

import _ from 'lodash';
import React, { useEffect } from 'react';
import { toJS, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { Loading } from '@tencent/spaui';

import { currencyFormatV2 } from '@/pages/agency/utils/format';

import { getTotalCostData } from '../../api';
import HomeItem from '../home-item';
import Summary, { SummaryTheme } from '../summary';
import store from '../../store';

import './index.scoped.less';

enum CostSummaryType {
  // 今日
  today = 'today',
  // 昨日
  yesterday = 'yesterday',
}

const CardCostSummary: React.FC<any> = observer((props) => {
  const { schema = [] } = props;
  const { todayCostData, yesterdayCostData } = store;

  useEffect(() => {
    getData(CostSummaryType.today);
    getData(CostSummaryType.yesterday);
  }, []);

  const getData = async (type: CostSummaryType) => {
    const parmas = {
      type,
    };
    try {
      const res = await getTotalCostData({
        key: `getTotalCost-${type}`,
        data: parmas,
      });
      const data = _.get(res, `data.${type}`, {});
      runInAction(() => {
        store[`${type}CostData`] = data;
      });
    } catch (error) {}
  };

  const data = {
    today: toJS(todayCostData),
    yesterday: toJS(yesterdayCostData),
  };

  const getValue = (v: Record<string, any>) => {
    if (_.isEmpty(data[_.get((v.key || '').split('.'), '0', 'today')])) {
      return <Loading />;
    }
    const value = _.get(data, v.key, 0);
    switch (v.key) {
      case 'today.total_balance':
      case 'today.total_cost':
      case 'yesterday.total_cost':
        return currencyFormatV2(value, true);
      case 'today.total_advertiser':
      case 'yesterday.total_advertiser':
        return currencyFormatV2(value);
    }
    return value;
  };

  if (!_.isArray(schema)) {
    return null;
  }

  return (
    <HomeItem>
      <div className="card-cost-summary">
        <Summary
          theme={SummaryTheme.theme1}
          schema={schema}
          getValue={getValue}
        />
      </div>
    </HomeItem>
  );
});

export default CardCostSummary;
